'use client'

import { usePageTracking } from '../hooks/usePageTracking.client'
import type { PageData } from '../services/tracking.eventTypes'

/**
 * Tracking page view directly from a RSC
 *
 * @example
 * function SomePage() {
 *   return (
 *     <>
 *       <PageTracking pageData={{ ... }} />
 *       {...}
 *     </>
 *   )
 * }
 */
export function PageTracking({
  pageData,
  productReference,
}: {
  pageData: PageData
  productReference?: string
}) {
  usePageTracking(pageData, productReference)

  return null
}
